import React from 'react';
import { ArrowForwardIos } from '@mui/icons-material';

interface CustomSummaryProps extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
}

const CustomSummary: React.FC<CustomSummaryProps> = ({ children, ...props }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <summary
      {...props}
      onClick={(e) => {
        setIsOpen(!isOpen);
        if (props.onClick) props.onClick(e);
      }}
    >
      <ArrowForwardIos
        sx={{
          mr: 2,
          fontSize: '1rem',
          color: 'ui.accent',
          transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease',
        }}
      />
      {children}
    </summary>
  );
};

export default CustomSummary;
